import {useEffect, useMemo, useState} from "react";
import {useLocation, useSearchParams} from "react-router-dom";
import {getCategories, resolveCategoryTitle} from "@corporatesclub/shared";
import {ProductListing} from "@/components/shop/ProductListing";

export function CategoryPageClient() {
  const {pathname} = useLocation();
  const [searchParams] = useSearchParams();
  const slug = useMemo(() => {
    const rest = pathname.replace(/^\/c\/?/, "");
    return rest ? rest.split("/").filter(Boolean) : ["placeholder"];
  }, [pathname]);
  const [c, sub, subsub, subsubsub] = slug;
  const sort = useMemo(() => {
    const raw = searchParams.get("sort");
    if(!raw) return undefined;
    const n = Number(raw);
    return Number.isFinite(n) ? n : undefined;
  }, [searchParams]);
  const query = {c, sub, subsub, subsubsub, sort};
  const fallbackTitle = slug.join(" / ").replace(/-/g, " ");
  const [title, setTitle] = useState(fallbackTitle);
  useEffect(() => {
    getCategories()
      .then((r) => {
        const resolved = resolveCategoryTitle(r.items, {c, sub, subsub, subsubsub});
        if(resolved) setTitle(resolved);
      })
      .catch(() => {});
  }, [c, sub, subsub, subsubsub]);
  return <ProductListing params={query} title={title} defaultSort={sort ?? 6} infiniteScroll={false} />;
}
